import UnpublishedQuestionDescriptionSkeleton from './UnpublishedQuestionDescription/skeleton';

export interface QuestionDescriptionSkeletonProps {
  className?: string;
}

const QuestionDescriptionSkeleton = ({ className }: QuestionDescriptionSkeletonProps) => {
  return <UnpublishedQuestionDescriptionSkeleton className={className} />;
};

export default QuestionDescriptionSkeleton;
